/* eslint-disable import/prefer-default-export */
import ModelType from 'enums/export/modelType.enum';

// We don't want to expose the "MergedOffer" verbiage to issuers
export const getExportModelDisplayName = (model: ModelType): ModelType =>
  model === ModelType.MergedOffer ? ModelType.Offer : model;
